import { render } from "./OffMelrosePage.vue?vue&type=template&id=f75019b6"
import script from "./OffMelrosePage.vue?vue&type=script&lang=js"
export * from "./OffMelrosePage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__